import { defineRouting } from "next-intl/routing";
import { locales, pathnames } from "@/config";

export const routing = defineRouting({
  locales,
  defaultLocale: "en",
  pathnames,
});

export type AppLocale = (typeof locales)[number];
export type AppPathnames = keyof typeof pathnames;
